import { AmcFeeEstimate } from '../../../services/documentForms/appraisalDetailsV2/appraisalDetailsV2Service';

export interface AmcOption {
  label: string;
  value: string;
  estimatedFee: number;
}

export const filterAmcsByFee = (amcs: AmcFeeEstimate[]): AmcFeeEstimate[] =>
  amcs.filter(amc => amc.estimatedFee > 0);

export const amcToOption = (amc: AmcFeeEstimate): AmcOption => ({
  label: amc.amcName,
  value: amc.amcName,
  estimatedFee: amc.estimatedFee,
});
